import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MasonryGridComponent } from './masonry-grid.component';
import { RouterModule } from '@angular/router';
import { MatChipsModule } from '@angular/material/chips';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from "@angular/material/tooltip";

const ANGULAR_MATERIAL_MODULES = [
  MatChipsModule, MatButtonModule, MatIconModule,
  MatTooltipModule
];

const COMPONENTS = [
  MasonryGridComponent
];

@NgModule({
  declarations: [...COMPONENTS],
  imports: [CommonModule, RouterModule, ...ANGULAR_MATERIAL_MODULES],
  exports: [MasonryGridComponent]
})
export class MasonryGridModule { }
